import angular from 'angular';

export default function AssignVendorManagersDialogController(
  $q,
  $scope,
  ssDialogService,
  alerts,
  loaderService,
  vmDataService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSaveDialog = handleSaveDialog;

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSaveDialog(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      _saveAssignments()
        .then(() => {
          loaderService.showViewLoader = false;
          _closeDialog();
        })
        .catch((err) => {
          alerts.error(err);
        });
    }
  }

  /** ***************************************
   * Private Functions
   */

  function _saveAssignments() {
    let vmIds = '';
    const assignedVendorManagers = [];

    angular.forEach(vm.vendorManagers, (vendorManager) => {
      if (vendorManager.isAssigned) {
        vmIds += `${vendorManager.vendorManagerId},`;
        assignedVendorManagers.push(vendorManager);
      }
    });

    vmIds = vmIds.substring(0, vmIds.length - 1);

    if (vmIds === '') {
      vmIds = '-1';
    }

    return vmDataService.assignVendorManagersByVendor(vm.vendorId, vmIds)
      .then(() => {
        alerts.success('Vendor Assignments saved successfully.');
        vm.addCallback(assignedVendorManagers);
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.assignVendorManagersDialog);
  }
}

AssignVendorManagersDialogController.$inject = [
  '$q',
  '$scope',
  'ssDialogService',
  'alerts',
  'loaderService',
  'vmDataService',
];
